// This is the token that is stored when the user is authenticated either here or
// in the Admin portal.
export class BearerToken {
  public access_token: string;
  public refresh_token: string;
  public token_type: string;
  public fullName: string;
  public roles: string;
  public email: string;
  public mobile: string;

  constructor(json: any) {
    Object.assign(this, json);
  }

  public issued(): Date {
    return this['.issued'];
  }

  public expires(): Date {
    return this['.expires'];
  }

  public isExpired(): boolean {
    return new Date(this.expires()) <= new Date();
  }
}
